// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__1fM8t","OrderButton":"BuildControls_OrderButton__3A6UD","enable":"BuildControls_enable__15PNh"};